import React from 'react'
import { Dialog } from 'antd-mobile'
import { useTranslation } from 'react-i18next'
import { CheckOutline, CloseOutline, InformationCircleOutline, ExclamationTriangleOutline } from 'antd-mobile-icons'
import classNames from 'classnames'
import style from './index.scss'

interface SettingResultProps {
  open: boolean
  onClose: () => void
  status?: 'success' | 'error' | 'info' | 'warning'
  title?: string
  subTitle?: string
  content?: string
}

const SettingResult: React.FC<SettingResultProps> = ({
  open,
  onClose,
  status = 'success',
  title,
  subTitle,
  content
}) => {
  const { t } = useTranslation()
  
  const getStatusIcon = () => {
    const iconClassName = classNames(style['setting-result-icon'], style[status])
    
    switch (status) {
      case 'success':
        return <CheckOutline className={iconClassName} />
      case 'error':
        return <CloseOutline className={iconClassName} />
      case 'warning':
        return <ExclamationTriangleOutline className={iconClassName} />
      case 'info':
      default:
        return <InformationCircleOutline className={iconClassName} />
    }
  }

  const confirmButtonText = t('settingResult.confirmButton', '确定')

  return (
    <Dialog
      visible={open}
      content={
        <div className={style['setting-result-content']}>
          <div>
            {getStatusIcon()}
          </div>
          {title && (
            <div className={style['setting-result-title']}>
              {title}
            </div>
          )}
          {subTitle && (
            <div className={style['setting-result-subtitle']}>
              {subTitle}
            </div>
          )}
          {content && (
            <div className={style['setting-result-content-text']}>
              {content}
            </div>
          )}
        </div>
      }
      actions={[
        {
          key: 'confirm',
          text: confirmButtonText,
          onClick: onClose
        }
      ]}
    />
  )
}

export default SettingResult